<section class="container account-summary">
  @if (orgUnits?.length) {
    <div [ngStyle]="{ height: showDetail ? 0 : 'auto' }">
      <tree-root class="accounts-tree" [ngStyle]="{ visibility: showTree ? 'visible' : 'hidden' }" [nodes]="orgUnits">
        <ng-template #treeNodeTemplate let-node let-index="index">
          <button
            class="btn btn-small node-button"
            [ngClass]="{
              'active-node': highlightActiveNode(node),
              'parent-yellow': node?.level == 1,
              'first-child-orange': node?.level == 2,
              'second-child-green': node?.level == 3
            }"
            (click)="toggleNode(node, $event)"
            >
            <span class="node-button-value" (click)="showOrgUnitDetail(node); $event.stopPropagation()">
              {{ node.data.name }}
            </span>
            @if (node.data?.children?.length) {
              <span> ({{ node.data.children.length }}) </span>
            }
          </button>
        </ng-template>
      </tree-root>
    </div>
    @if (showDetail) {
      <div>
        <button class="btn btn-action btn-small btn-back" (click)="showHideDetail(false)">
          <i class="fas fa-arrow-left mr-1"></i>
          Back To Accounts
        </button>
        @if (orgUnitDetail$ | async; as orgUnitDetail) {
          <mat-card>
            <h2>{{ orgUnitDetail.parentOrgUnit?.name }}</h2>
            <div>
              <div class="account-detail">
                <span class="account-detail-label">{{ 'accountSummary.id' | cxTranslate }}:</span>
                <p class="account-detail-value">{{ orgUnitDetail.uid }}</p>
              </div>
              <div class="account-detail">
                <span class="account-detail-label">{{ 'shared.name' | cxTranslate }}:</span>
                <p class="account-detail-value">{{ orgUnitDetail.name }}</p>
              </div>
              <div class="account-detail">
                <span class="account-detail-label">{{ 'accountSummary.address' | cxTranslate }}:</span>
                <p class="account-detail-value account-detail-address">
                  {{ orgUnitDetail.addresses?.length ? orgUnitDetail.addresses[0]?.formattedAddress : '' }}
                </p>
              </div>
            </div>
          </mat-card>
        } @else {
          @if (!showLoaderDetail) {
            <app-custom-error
              [errorMessage]="'accountSummary.noDetail' | cxTranslate"
            ></app-custom-error>
          }
        }
        @if (showLoaderDetail) {
          <div class="cx-spinner">
            <cx-spinner></cx-spinner>
          </div>
        }
      </div>
    }
  } @else {
    @if (!showLoader) {
      <app-custom-error [errorMessage]="'accountSummary.noUnits' | cxTranslate"></app-custom-error>
    }
  }
</section>



@if (showLoader) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
